import * as z from "zod";

const ColorOptionSchema = z.object({
  id: z.string(),
  title: z.string(),
});

export const ServiceMetadataSchema = z.object({
  service_type: z.string(),
  name: z.string().optional().default(""),
  service_mode: z.string(),
  description: z.string().nullable().optional(),
  recommendations: z.string().nullable().optional(),
  price_label: z.string().nullable().optional(),
  hint: z.string().nullable().optional(),
  icon_url: z.string().nullable().optional(),
  display_order: z.number().optional().default(0),
  enabled: z.boolean().optional().default(true),
  format_options: z.array(z.string()).optional().default([]),
  color_options: z.array(ColorOptionSchema).optional().default([]),
  duplex_available: z.boolean().optional().default(false),
  offline_available: z.boolean().optional().default(false),
  coming_soon: z.boolean().optional().default(false),
  has_variants: z.boolean().optional().default(false),
});

export type ServiceMetadata = z.infer<typeof ServiceMetadataSchema>;

export const ServiceListResponseSchema = z.object({
  services: z.array(ServiceMetadataSchema),
});

export const FilePriceSchema = z.object({
  file_id: z.string(),
  total_price: z.number(),
});

/**
 * Схема ответа для расчета цены услуги (старая ручка /api/services/price/calculate)
 */
export const CalculatePriceResponseSchema = z.object({
  files: z.array(FilePriceSchema),
  promo_discount: z.number().optional(),
  resources_available: z.any().optional(),
});

/**
 * Схема ответа для новой ручки /api/services/calculate
 * Включает проверку ресурсов и применение промокодов
 */
export const FilePriceDetailSchema = z.object({
  file_id: z.union([z.string(), z.number()]),
  pages: z.number(),
  total_pages: z.number(),
  copies: z.number(),
  price_per_unit: z.number(),
  total_price: z.number(),
  parameters: z.record(z.any()).nullable().optional(),
});

export const ServiceCalculateResponseSchema = z.object({
  total_price: z.number(),
  files: z.array(FilePriceDetailSchema),
  resources_sufficient: z.boolean(),
  missing_resources: z.array(z.string()),
  resources_details: z.string(),
});
